var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, FlexBox, Icon, Page, Tooltip } from '@dixa/lib-shared-habla';
import { uploadsApi } from 'apis/uploads';
import { waitMusicApi } from 'apis/waitMusic';
import { appActions } from 'app/app.actions';
import { analytics } from 'app/utils/segment';
import { AppLink } from 'components/appLink';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppNavigate } from 'utils/url/useAppNavigate';
import { FileUsagePageTable } from './components/table/table';
import { isAnnouncement } from './utils/typeguards/isAnnouncement';
export const FileUsagePage = ({ type, usage, file, asyncStatus, }) => {
    const navigate = useAppNavigate();
    const dispatch = useAppDispatch();
    const [deleteAnnouncement] = uploadsApi.useDeleteAnnouncementMutation();
    const [deleteWaitMusic] = waitMusicApi.useDeleteWaitMusicMutation();
    const name = (isAnnouncement(file) ? file === null || file === void 0 ? void 0 : file.pretty_name : file === null || file === void 0 ? void 0 : file.name) || 'Unnamed file';
    const redirectToAudioSettings = () => navigate({ path: '/settings/audio' });
    const handleDeleteAudioClick = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!file) {
            return;
        }
        const analyticsPayload = {
            type,
            filename: name,
        };
        analytics.settingsAudioDeleteClicked(analyticsPayload);
        const { isConfirmed } = yield dispatch(appActions.showModal({
            modal: {
                type: 'app:confirm',
                arg: {
                    title: 'Delete audio message?',
                    description: `Are you sure you want to delete the file "${name}"? Please note that this action can't be undone.`,
                    confirm: {
                        label: 'Delete',
                    },
                },
            },
        }));
        if (isConfirmed) {
            analytics.settingsAudioDeleteConfirmClicked(analyticsPayload);
            if (isAnnouncement(file)) {
                const [_, fileUUIDWithExtension] = file.url.match(/.+\/(.+\..{2,5})$/) || [];
                deleteAnnouncement({ file: fileUUIDWithExtension }).then(redirectToAudioSettings);
            }
            else {
                deleteWaitMusic({ id: file.id }).then(redirectToAudioSettings);
            }
        }
        else {
            analytics.settingsAudioDeleteCancelClicked(analyticsPayload);
        }
    });
    const isDeletable = usage.length === 0 && asyncStatus === 'fulfilled';
    return (_jsxs(Page, { children: [_jsx(Page.Head, { title: _jsxs(FlexBox, Object.assign({ gap: "200", alignItems: "center" }, { children: [_jsx(AppLink, Object.assign({ path: "/settings/audio", style: { color: 'inherit' } }, { children: "Audio files" })), _jsx(Icon, { name: "angle-right" }), name] })) }), _jsx(Page.Body, { children: _jsx(Page.Section, Object.assign({ title: "Flows using this audio file", controls: _jsx(_Fragment, { children: _jsx(Tooltip, Object.assign({ content: "The audio file must be removed from all flows, before it can be deleted.", disabled: isDeletable, wrap: "span", dark: true }, { children: _jsx(Button, Object.assign({ disabled: !isDeletable, variant: "danger", onClick: handleDeleteAudioClick }, { children: "Delete audio" })) })) }) }, { children: _jsx(FileUsagePageTable, { type: type, filename: name, usage: usage, asyncStatus: asyncStatus }) })) })] }));
};
